import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./_variables.scss";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import ChangePassword from "./pages/ChangePassword";
import Fragenbogen from "./pages/Fragenbogen";
import Dashboard from "./pages/Dashboard";
import MaturityOverview from "./pages/MaturityOverview";
import MaturityRadar from "./pages/MaturityRadar";
import LevelAchievement from "./pages/LevelAchievement";
import NextSteps from "./pages/NextSteps";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Impressum from "./pages/Impressum";
import EmailVerification from "./pages/EmailVerification";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import DashboardAdmin from "./pages/DashboardAdmin";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";

/**
 * @description Main application component that sets up routing and manages cookie consent banner.
 * @returns {JSX.Element} Application with routes and navigation
 */
function App() {
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("cookieConsent");

    if (!saved) {
      setShowCookieBanner(true);
    }
  }, []);

  return (
    <Router>
      {showCookieBanner && (
        <CookieBanner onClose={() => setShowCookieBanner(false)} />
      )}

      <Navbar />

      <Routes>
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedAdminRoute>
              <DashboardAdmin />
            </ProtectedAdminRoute>
          }
        />
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<EmailVerification />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/fragenbogen" element={<Fragenbogen />} />
        <Route path="/dashboard" element={<Dashboard />}>
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<MaturityOverview />} />
          <Route path="radar" element={<MaturityRadar />} />
          <Route path="levels" element={<LevelAchievement />} />
          <Route path="next-steps" element={<NextSteps />} />
        </Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/impressum" element={<Impressum />} />
      </Routes>

      <Footer openCookies={() => setShowCookieBanner(true)} />
    </Router>
  );
}

export default App;
